import validateMessages from './validateMessages'
import moment from 'moment';
export const validateLetters = (data: any) => {
    if (data === undefined || data === null || data === "") {
        return Promise.reject("");
    } else {
        const regex = /^[a-zA-Z\s]*$/;
        const isValid = regex.test(data);
        if (!isValid) {
            return Promise.reject(new Error(validateMessages.onlyLetters));
        } else {
            return Promise.resolve();
        }
    }
};

export const validateNumber = (data: any) => {
    if (data === undefined || data === null || data === "") {
        return Promise.reject("");
    } else {
    
        const regex = /^-?\d*(\.\d*)?$/;
        const isValid = regex.test(data);
        if (!isValid) {
            return Promise.reject(new Error(validateMessages.onlyNumbers));
        } else {
            return Promise.resolve();
        }
    }
};

export const validatePassword= (password: string,confirmpassword:string) => {

    if (confirmpassword == null || confirmpassword == undefined || confirmpassword == "") {
        return validateMessages.validatePassword
    }
    if (confirmpassword != password) {
        return validateMessages.validatePasswords
    }

    if (password.length < 8 || password.length > 14) {
        return validateMessages.validatePasswordLength
    }

    let tieneMayuscula = false;
    let tieneNumero = false;

    for (const char of password) {
        if (char >= 'A' && char <= 'Z') {
            tieneMayuscula = true;
        } else if (char >= '0' && char <= '9') {
            tieneNumero = true;
        }
    }
    if(!tieneMayuscula){
        return validateMessages.validatePasswordCapitalLetter
    }
    if(!tieneNumero){
        return validateMessages.validatePasswordNumber
    }

    return "";
}


export const validateIdentification = (cedula: any, datatype: any) => {
    if (datatype == undefined) {
        return validateMessages.selectType;
    } else {
        if (cedula === undefined || cedula === null || cedula === "") {
            return "";
        } else {
            switch (datatype) {
                case "CC":
                    if (!/[0-9]|\./.test(cedula)) {
                        return validateMessages.onlyNumbers;
                    } else {
                        if (cedula.length === 10) {


                            const digitoRegion = cedula.substring(0, 2);


                            if (digitoRegion >= String(0) && digitoRegion <= String(24)) {

                                const ultimoDigito = Number(cedula.substring(9, 10));


                                const pares = Number(cedula.substring(1, 2)) + Number(cedula.substring(3, 4)) + Number(cedula.substring(5, 6)) + Number(cedula.substring(7, 8));


                                let numeroUno: any = cedula.substring(0, 1);
                                numeroUno = (numeroUno * 2);
                                if (numeroUno > 9) {
                                    numeroUno = (numeroUno - 9);
                                }

                                let numeroTres: any = cedula.substring(2, 3);
                                numeroTres = (numeroTres * 2);
                                if (numeroTres > 9) {
                                    numeroTres = (numeroTres - 9);
                                }

                                let numeroCinco: any = cedula.substring(4, 5);
                                numeroCinco = (numeroCinco * 2);
                                if (numeroCinco > 9) {
                                    numeroCinco = (numeroCinco - 9);
                                }

                                let numeroSiete: any = cedula.substring(6, 7);
                                numeroSiete = (numeroSiete * 2);
                                if (numeroSiete > 9) {
                                    numeroSiete = (numeroSiete - 9);
                                }

                                let numeroNueve: any = cedula.substring(8, 9);
                                numeroNueve = (numeroNueve * 2);
                                if (numeroNueve > 9) {
                                    numeroNueve = (numeroNueve - 9);
                                }

                                const impares = numeroUno + numeroTres + numeroCinco + numeroSiete + numeroNueve;


                                const sumaTotal = (pares + impares);


                                const primerDigitoSuma = String(sumaTotal).substring(0, 1);


                                const decena = (Number(primerDigitoSuma) + 1) * 10;


                                let digitoValidador = decena - sumaTotal;


                                if (digitoValidador === 10) {
                                    digitoValidador = 0;
                                }


                                if (digitoValidador !== ultimoDigito) {
                                    return validateMessages.invalidIdentification;
                                }

                            } else {

                                return validateMessages.invalidRegionIdentification;
                            }
                        } else {

                            return validateMessages.onlyTenNumbers;
                        }

                    }
                    break;
                case "CE":
                    if (cedula.length >= 4 && cedula.length <= 10) {
                        if (!/^[0-9A-Z]+$/.test(cedula)) {
                            return validateMessages.onlyUpperLettersAndNumbers;
                        }
                    }
                    else {
                        return validateMessages.indentificationCEValidation;
                    }
                    break;
            }

        }

    }

    return "";
};

export const validatePhoneEC = (data: any) => {
    if (data === undefined || data === null || data === "") {
        return Promise.reject("");
    } else {
        const regex = /[0-9]|\./;
        const isValid = regex.test(data);
        if (!isValid) {
            return Promise.reject(new Error(validateMessages.onlyNumbers));
        } else {  
    
                if (data.substring(0, 2) !== "09") {
                    return Promise.reject(new Error(validateMessages.onlyCCPhone));
                }else{              
                    if (data.length === 10) {
                        return Promise.resolve();                    
    
                    } else {
                        return Promise.reject(new Error(validateMessages.onlyTenNumbers));
                    }
                  
                }
          
        }


    }
};

export const validateBirthday = (data: any) => {      
        
        const actualDate = new Date();  
        const age =Number(moment(actualDate).format("YYYY"))-data.$y ;   

        if(age < 18){
            return Promise.reject(new Error(validateMessages.validateBirthday));
        }else{
            return Promise.resolve();    
        }
        
    
};

export const validate1 = (data: any) => {
    const inputLength = data.length;

    if (inputLength !== 1) {
        return Promise.reject(new Error("La longitud máxima es de 1 caracter."));
    } else {
        return Promise.resolve();
    }
};
export const validate5 = (data: any) => {
    const inputLength = data.length;

    if (inputLength !== 5) {
        return Promise.reject(new Error("La longitud máxima es de 5 caracter."));
    } else {
        return Promise.resolve();
    }
};
export const validate5Max = (data: any) => {
    const inputLength = data.length;

    if (inputLength > 5) {
        return Promise.reject(new Error("La longitud máxima es de 5 caracter."));
    } else {
        return Promise.resolve();
    }
};

export const validate15 = (data: any) => {
    if (data.length > 15) {
        return Promise.reject(new Error("La longitud debe ser menor o igual a 15 caracteres."));
    } else {
        return Promise.resolve();
    }
};

export const validate150 = (data: any) => {
    const inputLength = data.length;
    if(inputLength == 0){

    }
    else if (inputLength > 150) {
        return Promise.reject(new Error("La longitud máxima es de 150 caracteres."));
    } else {
        return Promise.resolve();
    }
};

export const validate100 = (data: any) => {
    const inputLength = data.length;

    if (inputLength > 100) {
        return Promise.reject(new Error("La longitud máxima es de 100 caracteres."));
    } else {
        return Promise.resolve();
    }
};

export const validate125 = (data: any) => {
    const inputLength = data.length;

    if (inputLength > 125) {
        return Promise.reject(new Error("La longitud máxima es de 125 caracteres."));
    } else {
        return Promise.resolve();
    }
};

export const validate255 = (data: any) => {
    const inputLength = data.length;

    if (inputLength > 255) {
        return Promise.reject(new Error("La longitud máxima es de 255 caracteres."));
    } else {
        return Promise.resolve();
    }
};

export const validate200 = (data: any) => {
    const inputLength = data.length;

    if (inputLength > 200) {
        return Promise.reject(new Error("La longitud máxima es de 200 caracteres."));
    } else {
        return Promise.resolve();
    }
};

export const validateDecimal4 = (data: any) => {
    const regex = /^\d+(\.\d{1,7})?$/;

    if (!regex.test(data)) {
        return Promise.reject(new Error("Por favor, introduce un número con un máximo de 7 decimales."));
    } else {
        return Promise.resolve();
    }
};

export const validate60 = (data: any) => {
    const inputLength = data.length;

    if (inputLength > 60) {
        return Promise.reject(new Error("La longitud máxima es de 60 caracteres."));
    } else {
        return Promise.resolve();
    }
};

export const validateYear4 = (data: string) => {    
    const currentYear = new Date().getFullYear();
    const dataString = data.toString(); // Convertir el número a cadena para obtener su longitud

    if (dataString.length !== 4) {
        return Promise.reject(new Error("Ingresa un número de 4 dígitos válido"));
    } else {
        return Promise.resolve();
    }
};

export const validateDigitLength = (data: any) => {
    const isDigitsOnly = /^\d+$/.test(data);

    if (data.length > 20) {
        return Promise.reject(new Error("Asegúrate de que la longitud menor o igual a 20."));
    } else {
        return Promise.resolve();
    }
};

export const validateLettersAndLength = (data: any) => {
    const isLettersOnlyWithSpaces = /^[a-zA-Z\u00C0-\u024F\s]+$/.test(data);

    if (!isLettersOnlyWithSpaces || data.length > 150) {
        return Promise.reject(new Error("Ingresa solo letras y asegúrate de que la longitud sea menor o igual a 150."));
    } else {
        return Promise.resolve();
    }
};

export const validateAndLength = (data: any) => { 

    if (data.length > 150) {
        return Promise.reject(new Error("asegúrate de que la longitud sea menor o igual a 150."));
    } else {
        return Promise.resolve();
    }
};
export const validatenames = (data: any) => {
    const isLettersOnlyWithSpaces = /^[a-zA-Z\u00C0-\u024F\s]+$/.test(data);

    if (!isLettersOnlyWithSpaces || data.length > 150) {
        return Promise.reject(new Error("Ingresa solo letras y asegúrate de que la longitud sea menor o igual a 150."));
    } else {
        return Promise.resolve();
    }
};

export const validateHourFormat = (data: any) => {
    const isValidHourFormat = /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/.test(data);

    if (!isValidHourFormat) {
        return Promise.reject(new Error("Por favor, ingresa una hora válida en el formato hh:mm."));
    } else {
        return Promise.resolve();
    }
};








